import { makeStyles } from '@mui/styles';
import { NextTheme } from '../../layout/theme-next/provider';

const ADORNMENT_MARGIN = 5;

export default makeStyles<NextTheme>(theme => ({
  editor: {
    '& .MuiFormHelperText-root': {
      paddingLeft: 0,
    },
  },
  toleranceField: {
    margin: theme.spacing(0, 0, 0, ADORNMENT_MARGIN),
  },
  toleranceAdornment: {
    position: 'relative',
    padding: 0,
    marginLeft: theme.spacing(-ADORNMENT_MARGIN - 1),
  },
}));
